import { Outlet, useLocation } from "react-router-dom";
import Header from '../components/Header';
import BlogDetailHeader from "../components/BlogDetailHeader";
import Footer from '../components/Footer';
import React from "react";
const Layout = ({ footerHide }) => {
  const { pathname } = useLocation();
  const isBlogDetail = /^\/blogs\/[^/]+\/?$/.test(pathname);
  const isSpecialPage =
    pathname === "/404" ||
    pathname === "/thank-you";

  const showBlogDetailHeader = isBlogDetail || isSpecialPage;
  const hideFooter =
     pathname === "/404" ||
    pathname === "/thank-you";

  return (
    <div>
      {showBlogDetailHeader ? <BlogDetailHeader /> : <Header />}

      <main>
        <Outlet />
      </main>

      {!hideFooter && <Footer footerHide={footerHide} />}
    </div>
  );
};

export default Layout;
